import { render, staticRenderFns } from "./ActivityTab.vue?vue&type=template&id=5e4c3d91&scoped=true"
import script from "./ActivityTab.vue?vue&type=script&lang=js"
export * from "./ActivityTab.vue?vue&type=script&lang=js"
import style0 from "./ActivityTab.vue?vue&type=style&index=0&id=5e4c3d91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c3d91",
  null
  
)

export default component.exports